import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGrowth: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGrowth"><Path d="M3 3V5C3 9.41828 6.58172 13 11 13V21H13V16C17.4183 16 21 12.4183 21 8V6H19C16.4707 6 14.2156 7.17377 12.7496 9.0063C11.8637 5.55265 8.72995 3 5 3H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGrowth;
